/* ODAVIA recently viewed - original code. localStorage stores only handle+timestamp; live product data fetched at render for correct price/currency/title/image. */
(function(){
  if (customElements.get('odavia-recent')) return;
  var KEY = 'odavia:recent:v2';
  var MAX = 12;

  function readList(){
    var list = [];
    try { list = JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list)) list = [];
    return list.filter(function(x){ return x && typeof x.h === 'string'; });
  }
  function writeList(list){
    try { window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  class OdaviaRecent extends HTMLElement {
    connectedCallback(){
      var self = this;
      var current = this.dataset.current || '';
      var list = readList();

      // Record current product (handle + timestamp only)
      var here = this.dataset.handle;
      if (here) {
        list = list.filter(function(p){ return p.h !== here; });
        list.unshift({ h: here, ts: Date.now() });
        writeList(list);
      }

      var limit = parseInt(this.dataset.limit || '5', 10);
      var handles = list.map(function(p){ return p.h; })
        .filter(function(h){ return h && h !== current; })
        .slice(0, limit);
      if (!handles.length) { this.hidden = true; return; }

      var grid = this.querySelector('[data-grid]');
      if (!grid) return;

      Promise.all(handles.map(function(h){
        return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function(r){ return r.ok ? r.json() : null; })
          .catch(function(){ return null; });
      })).then(function(products){
        var pruned = readList();
        var frag = document.createDocumentFragment();
        var shown = 0;
        products.forEach(function(prod, idx){
          var handle = handles[idx];
          if (!prod) {
            // Product deleted/unavailable -> drop from history
            pruned = pruned.filter(function(p){ return p.h !== handle; });
            return;
          }
          frag.appendChild(self._card(prod));
          shown++;
        });
        writeList(pruned);
        if (!shown) { self.hidden = true; return; }
        grid.textContent = '';
        grid.appendChild(frag);
        self.hidden = false;
      });
    }

    _money(cents){
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }

    _shortTitle(title){
      var t = String(title || '');
      var cut = -1;
      [' \u2013 ', ' \u2014 '].forEach(function(sep){
        var i = t.indexOf(sep);
        if (i > 0 && (cut === -1 || i < cut)) cut = i;
      });
      return cut > 0 ? t.slice(0, cut) : t;
    }

    _card(prod){
      var a = document.createElement('a');
      a.className = 'odavia-recent__card';
      a.href = prod.url || ('/products/' + prod.handle);

      var media = document.createElement('span');
      media.className = 'odavia-recent__media';
      var img = document.createElement('img');
      var u = prod.featured_image || (prod.images && prod.images[0]) || '';
      if (u) img.src = u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      img.alt = prod.title || '';
      img.loading = 'lazy';
      img.width = 600; img.height = 600;
      media.appendChild(img);
      a.appendChild(media);

      var t = document.createElement('span');
      t.className = 'odavia-recent__title';
      t.textContent = this._shortTitle(prod.title);
      a.appendChild(t);

      // Nur der aktuelle Preis – kein Streichpreis; "Ab" bei Preisspannen (wie auf den Produktkarten)
      var price = typeof prod.price === 'number' ? prod.price : null;
      if (price !== null) {
        var p = document.createElement('span');
        p.className = 'odavia-recent__price';
        p.textContent = (prod.price_varies ? 'Ab ' : '') + this._money(price);
        a.appendChild(p);
      }
      return a;
    }
  }
  customElements.define('odavia-recent', OdaviaRecent);
})();
